import React, { useState } from "react";
import { getCardImage } from "../../resultVisuals/cardAssets";
import FlipCard from "./FlipCard";

/**
 * 20-20 Teenpatti (teen20 / pteen20 / teen20b) card overlay — reference markup:
 *   .casino-video-cards[.hide-cards] > .casino-cards-shuffle (toggle) + .casino-video-cards-container
 *     ([h4 Player A] div(3 cards) [h4 Player B] div(3 cards))
 * Card order (reference): A = cards[0,2,4], B = cards[1,3,5]. "1" = card not dealt (back image).
 * Hidden (.hide-cards) while cards[0] is "1" or after the shuffle toggle; teen20b has no player headings.
 */
export default function Teen20RefCardsOverlay({ cards: rawCards, showNames = true }) {
  const [showCards, setShowCards] = useState(true);
  const cards = (Array.isArray(rawCards) ? rawCards : String(rawCards || "").split(",")).map((c) =>
    String(c ?? "").trim()
  );
  if (!rawCards || !cards.length) return null;

  const hide = !showCards || cards[0] === "1";

  if (cards[0] === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  const card = (token, key) => (
    <span key={key}>
      <FlipCard src={getCardImage(token)} alt="" />
    </span>
  );
  const row = (idx) => (
    <div>
      {card(cards[idx[0]], 0)} {card(cards[idx[1]], 1)} {card(cards[idx[2]], 2)}
    </div>
  );

  return (
    <div className={`casino-video-cards${hide ? " hide-cards" : ""}`}>
      <div className="casino-cards-shuffle" onClick={() => cards[0] !== "1" && setShowCards((v) => !v)}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        {showNames && (
          <>
            <h4 className="text-left text-white text-uppercase">Player A</h4>{" "}
          </>
        )}
        {row([0, 2, 4])}{" "}
        {showNames && (
          <>
            <h4 className="text-left text-white text-uppercase">Player B</h4>{" "}
          </>
        )}
        {row([1, 3, 5])}
      </div>
    </div>
  );
}
